import(/* webpackMode: "eager", webpackExports: ["Badge"] */ "/home/runner/work/care_link_worker/care_link_worker/node_modules/@mantine/core/esm/components/Badge/Badge.mjs");
;
import(/* webpackMode: "eager" */ "/home/runner/work/care_link_worker/care_link_worker/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/care_link_worker/care_link_worker/src/app/_components/_css/Home.module.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/care_link_worker/care_link_worker/src/app/_components/HomeCta.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/care_link_worker/care_link_worker/src/util/userNotifications/index.ts");
